export const extensions = {
  abap: ['ABAP'],
  ada: ['Ada'],
  adb: ['Ada'],
  ads: ['Ada'],
  applescript: ['AppleScript'],
  as: ['ActionScript'],
  asax: ['aspx-cs'],
  ascx: ['aspx-cs'],
  ashx: ['aspx-cs'],
  asm: ['NASM'],
  asmx: ['aspx-cs'],
  aspx: ['aspx-cs'],
  asy: ['Asymptote'],
  au3: ['AutoIt'],
  aux: ['TeX'],
  axd: ['aspx-cs'],
  b: ['Brainfuck'],
  bas: ['VB.net'],
  bash: ['Shell'],
  bat: ['Batchfile'],
  befunge: ['Befunge'],
  bf: ['Brainfuck'],
  boo: ['Boo'],
  c: ['C'],
  'c++': ['C++'],
  'c++-objdump': ['C++Objdump'],
  cc: ['C++'],
  ceylon: ['Ceylon'],
  cfc: ['Coldfusion HTML'],
  cfg: ['INI'],
  cfm: ['Coldfusion HTML'],
  cfml: ['Coldfusion HTML'],
  cfs: ['Coldfusion'],
  cl: ['Common Lisp'],
  clj: ['Clojure'],
  cls: ['Apex'],
  cmake: ['CMake'],
  cmd: ['Batchfile'],
  coffee: ['CoffeeScript'],
  cpp: ['C++'],
  'cpp-objdump': ['C++Objdump'],
  cs: ['C#'],
  csh: ['Tcsh'],
  css: ['CSS'],
  cw: ['Redcode'],
  cxx: ['C++'],
  'cxx-objdump': ['C++Objdump'],
  d: ['D'],
  'd-objdump': ['D Objdump'],
  def: ['Modula-2'],
  di: ['D'],
  diff: ['Diff'],
  dylan: ['Dylan'],
  e: ['Euphoria'],
  ebuild: ['Shell'],
  eclass: ['Shell'],
  el: ['Common Lisp'],
  erl: ['Erlang'],
  'erl-sh': ['Erlang'],
  evoque: ['Evoque'],
  ex: ['Elixir'],
  f: ['Fortrain'],
  f90: ['Fortrain'],
  fan: ['Fantom'],
  feature: ['Gherkin'],
  flx: ['Felix'],
  flxh: ['Felix'],
  frag: ['GLSL'],
  g: ['Antlr'],
  gemspec: ['Ruby'],
  geo: ['GLSL'],
  go: ['Go'],
  h: ['C'],
  'h++': ['C++'],
  haml: ['Haml'],
  hh: ['C++'],
  hhi: ['Hack'],
  hpp: ['C++'],
  hrl: ['Erlang'],
  hs: ['Haskell'],
  htaccess: ['ApacheConf'],
  htm: ['HTML'],
  html: ['HTML'],
  hx: ['haXe'],
  hxx: ['C++'],
  inc: ['POVRay'],
  ini: ['INI'],
  io: ['Io'],
  j: ['Objective-J'],
  java: ['Java'],
  js: ['JavaScript'],
  json: ['JSON'],
  jsp: ['Java Server Page'],
  kid: ['Genshi'],
  ksh: ['Shell'],
  las: ['Lasso'],
  lasso: ['Lasso'],
  lassoapp: ['Lasso'],
  lgt: ['Logtalk'],
  lhs: ['Literate Haskell'],
  lisp: ['Common Lisp'],
  ll: ['LLVM'],
  ls: ['LiveScript'],
  lua: ['Lua'],
  ly: ['LilyPond'],
  m: ['Matlab', 'Objective-C', 'Octave'],
  mak: ['Makefile'],
  man: ['Groff'],
  mao: ['Mako'],
  ml: ['OCaml'],
  mli: ['OCaml'],
  mll: ['OCaml'],
  mly: ['OCaml'],
  mo: ['Modelica'],
  mod: ['Modula-2'],
  moo: ['MOOCode'],
  mu: ['MuPAD'],
  mxml: ['MXMLl'],
  myt: ['Myghty'],
  nim: ['Nimrod'],
  ns2: ['Newspeak'],
  objdump: ['objdump'],
  ooc: ['Ooc'],
  pas: ['Delphi'],
  patch: ['Diff'],
  php: ['PHP'],
  php3: ['PHP'],
  php4: ['PHP'],
  php5: ['PHP'],
  phtml: ['HTML+PHP'],
  pl: ['Perl', 'Prolog'],
  plot: ['Gnuplot'],
  plt: ['Gnuplot'],
  pm: ['Perl'],
  po: ['Gettext catalog'],
  pot: ['Gettext catalog'],
  pov: ['POVRay'],
  pro: ['Prolog'],
  prolog: ['Prolog'],
  properties: ['INI'],
  py: ['Python'],
  pyd: ['Cython'],
  pyi: ['Cython'],
  pyw: ['Python'],
  pyx: ['Cython'],
  r: ['REBOL'],
  r3: ['REBOL'],
  rake: ['Ruby'],
  rb: ['Ruby'],
  rbw: ['Ruby'],
  rbx: ['Ruby'],
  rest: ['reStructuredText'],
  rhtml: ['RHTML'],
  rl: ['Ragel'],
  rout: ['RConsole'],
  rs: ['Rust'],
  rss: ['XML'],
  rst: ['reStructuredText'],
  s: ['GAS'],
  sass: ['Sass'],
  sc: ['Python'],
  scala: ['Scala'],
  scm: ['Scheme'],
  sh: ['Shell'],
  'sh-session': ['Shell session'],
  spt: ['Cheetah'],
  sql: ['SQL'],
  'sqlite3-console': ['sqlite3con'],
  st: ['Smalltalk'],
  tac: ['Python'],
  tcl: ['Tcl'],
  tcsh: ['Tcsh'],
  tex: ['TeX'],
  tgr: ['Apex'],
  tmpl: ['Cheetah'],
  toc: ['TeX'],
  tpl: ['Smarty'],
  ts: ['TypeScript'],
  txt: ['Text'],
  uc: ['UnrealScript'],
  vala: ['Vala'],
  vapi: ['Vala'],
  vert: ['GLSL'],
  vg: ['VB.net'],
  vim: ['VimL'],
  vimrc: ['VimL'],
  weechatlog: ['IRC logs'],
  wsdl: ['XML'],
  xhtml: ['HTML'],
  xml: ['XML'],
  xsd: ['XML'],
  xsl: ['XSLT'],
  xslt: ['XSLT'],
  xtend: ['XTend'],
  yaml: ['YAML'],
};

export const filenames = {
  'apache.conf': ['ApacheConf'],
  'apache2.conf': ['ApacheConf'],
  autodelegate: ['Myghty'],
  gnumakefile: ['Makefile'],
  Makefile: ['Makefile'],
  pytb: ['Python'],
  Rakefile: ['Ruby'],
  SConstruct: ['Python'],
  SConscript: ['Python'],
  'squid.conf': ['SquidConf'],
};

const getExtension = (filename: string): string | null | undefined => {
  const split = filename.split('.');
  return split.length > 1 ? split.pop() : null;
};

export default function getLanguages(filename: string): string[] {
  const ext = getExtension(filename);
  // @ts-ignore TODO: fix noImplicitAny error here
  const byExt = ext ? extensions[ext] : undefined;

  // @ts-ignore TODO: fix noImplicitAny error here
  return filenames[filename] || byExt || [];
}
